import { StateCreator } from 'zustand';
import { IKamFlagData, IKamFlag } from './kameleoonFlags.interface';

export const kamFlagDataSlice: StateCreator<IKamFlagData> = (set) => ({
  kamFlags: {},
  setKamFlags(data: Record<string, IKamFlag> | null) {
    set(() => ({ kamFlags: data }));
  },
});
